export default "__VITE_ASSET__36aa3b86__"